export const _driver = 'localforage-driver-memory';
